import { render, staticRenderFns } from "./ThrowPapers.vue?vue&type=template&id=b3d74304&"
import script from "./ThrowPapers.vue?vue&type=script&lang=js&"
export * from "./ThrowPapers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports